/**
 * @file: findServiceSubjectIndex.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */
import { ServiceSubjectItem } from '@euler/app/flows/order/pages/ServiceSubjectsScreen/types';
import { OrderExtra } from '@euler/app/flows/order/types';
import { ServiceSubjectType } from '@euler/model/enum';

export function findServiceSubjectIndex(
  orderDetail: OrderExtra,
  item: ServiceSubjectItem,
) {
  return (
    orderDetail.serviceSubjects?.findIndex(x => {
      if (
        x.type === ServiceSubjectType.Inspection &&
        item.type === ServiceSubjectType.Inspection
      ) {
        return x.templateId === item.template.cid;
      }
      return x.type === item.type && x.name === item.title;
    }) ?? -1
  );
}
